export default __webpack_public_path__ + "static/media/Didot_Bold.63f0d232.otf";